import React, { useEffect, useState } from "react";
import {
  Col,
  Row,
  Button,
  Image,
  ButtonGroup,
  ToggleButton,
  Container,
  Form,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import {
  createSubscription,
  getApi,
  subscriptionSuccess,
} from "../../../../actions/structure.action";
import { toast } from "react-toastify";
import { getLogisticPartners, getUserSubscription } from "../../../../actions/user.actions";
import TimestampConverter from "../../../../utils/TimestampConverter";
import { tableStructures } from "../../../../helpers/table-structures";
import CustomTable from "../../common/CustomTable";
import isEmpty from "../../../../utils/is-Empty";
import "./index.css";
import PageSpinner from "../../../common/PageSpinner";
import { useNavigate } from "react-router-dom";
import { useDialog } from "../../../../helpers/useDialog";
import bhareeBlack from "../../../../assets/images/BhareeBlack.png";
import { capitalize } from "lodash";
import { store, stringConstants, userSubscriptionFeatures } from "../../../../helpers";
import BhareeSubscriptionGeneric from "../../../auth/BhareeSubscriptionGeneric";
import { BHAREE_BASE_URL_LOCAL } from "../../../../config/config.url";
import axios from "axios";
import { logoutUser } from "../../../../actions/auth.actions";

let options = {
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Authorization: `Bearer ${localStorage.jwtToken}`,
  },
};

const loadRazorpay = () => {
  return new Promise((resolve) => {
    // ✅ If already loaded, just resolve
    if (document.querySelector("#razorpay-script")) {
      return resolve(true);
    }

    const script = document.createElement("script");
    script.id = "razorpay-script";
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

const removeRazorpay = () => {
  const script = document.querySelector("#razorpay-script");
  if (script) {
    script.remove();
  }
};

const Subscriptions = () => {
  const { alert, confirm, DialogModal } = useDialog();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [subscriptionData, setSubscriptionData] = useState([]);
  const [mySubscription, setMySubscription] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [loading, setLoading] = useState(false);
  const [subscriptionDisplayFeatures, setSubscriptionDisplayFeatures] = useState([]);
  const [bhareeFee, setBhareeFee] = useState(null);
  const [showChangePlan, setShowChangePlan] = useState(false);
  const [showLeadsPlan, setShowLeadsPlan] = useState(false);
  const [showLeadsPlanClose, setShowLeadsPlanClose] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  const { auth, subscriptionPlans, userSubscriptionInfo, serviceTaxDetails } = useSelector(
    (state) => {
      return state;
    },
  );

  useEffect(() => {
    getApi("getSubscriptionPlans", dispatch);
    getApi("getServiceTaxDetails", dispatch);
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(subscriptionPlans?.data)) {
      setSubscriptionData(subscriptionPlans?.data);
    } else {
      setSubscriptionData([]);
    }
  }, [subscriptionPlans]);

  useEffect(() => {
    if (!isEmpty(subscriptionData) && subscriptionData?.length > 0) {
      let mInitial = subscriptionData[0];
      if (isEmpty(selectedPlan)) {
        setSelectedPlan(mInitial);
      }
    }
  }, [subscriptionData]);

  useEffect(() => {
    if (auth && auth.user && auth.user.id) {
      // Fetch user subscription details if needed
      getUserSubscription(auth.user.id, dispatch).then((res) => {
        // console.log("Use Effect: getUserSubscription: ", res);
      });
    }
  }, [auth, dispatch]);

  useEffect(() => {
    if (userSubscriptionInfo && userSubscriptionInfo.data) {
      setMySubscription(userSubscriptionInfo.data);
    }
  }, [userSubscriptionInfo]);

  useEffect(() => {
    if (!isEmpty(mySubscription) && !isEmpty(mySubscription?.subscriptionFeatures?.name)) {
      const displayFeatures = userSubscriptionFeatures[mySubscription?.subscriptionFeatures?.name];
      setSubscriptionDisplayFeatures(displayFeatures);

      if (mySubscription?.subscriptionFeatures?.name === "leads") {
        setShowLeadsPlanClose(false);
        if (mySubscription?.sellerInfo?.is_trial) {
          setShowLeadsPlan(true);
        } else if (
          !mySubscription?.sellerInfo?.is_trial &&
          mySubscription?.invoices &&
          mySubscription?.invoices?.length <= 0
        ) {
          setShowLeadsPlan(true);
        } else {
          setShowLeadsPlan(false);
        }
      }
    }
  }, [mySubscription]);

  useEffect(() => {
    if (!isEmpty(serviceTaxDetails?.data)) {
      if (mySubscription?.sellerInfo?.app_features === "starter") {
        setBhareeFee(serviceTaxDetails?.data?.starterFee);
      } else if (mySubscription?.sellerInfo?.app_features === "booster") {
        setBhareeFee(serviceTaxDetails?.data?.boosterFee);
      } else {
        setBhareeFee(null);
      }
    }
  }, [serviceTaxDetails, mySubscription]);

  const handleSubscribeNow = async (plan) => {
    const loaded = await loadRazorpay();
    if (!loaded) {
      await alert("Razorpay SDK failed to load. Check your internet connection.");
      return;
    }

    // Implement subscription logic here
    const response = await createSubscription({ plan_id: plan.id }, dispatch);
    // console.log("Create Subscription Response: ", response);

    if (response && response.data && response.data.id) {
      const options = {
        key: process.env.REACT_APP_RZRPAY_KEY_ID, // Enter the Key ID generated from the Dashboard
        subscription_id: response.data.id,
        name: "Bharee Beverages Ecomm Pvt. Ltd.",
        description: `Subscription for ${plan.plan_title}. ${plan.plan_subtitle}.`,
        handler: async function (response) {
          console.log("Razorpay payment response: ", response);

          setLoading(true);

          setTimeout(async () => {
            // Send response.razorpay_payment_id and subscriptionId to your backend
            const serverRes = await subscriptionSuccess(response, dispatch);

            console.log("Server response after subscription success: ", serverRes);
            toast.success("Subscription successful!");

            setTimeout(() => {
              alert("Subscription successful! Payment ID: " + response.razorpay_payment_id);
            }, 500);

            // Fetch user subscription details if needed
            getUserSubscription(auth.user.id, dispatch).then((res) => {
              console.log("After Subscription Get Response: ", res);
              setLoading(false);
              setMySubscription(res);
            });
          }, 2000); // Wait for 2 seconds for subscription to get updated by default

          // ✅ Clean up after success
          removeRazorpay();
        },
        config: {
          display: {
            hide: [{ method: "paylater" }, { method: "emi" }, { method: "wallet" }],
            preferences: { show_default_blocks: true },
            widget: {
              main: {
                isDarkMode: true, //default is false
              },
            },
          },
        },
        modal: {
          confirm_close: true, // this is set to true, if we want confirmation when clicked on cross button.
          ondismiss: async (reason) => {
            console.log("Checkout closed by user");
            const {
              reason: paymentReason,
              field,
              step,
              code,
            } = reason && reason.error ? reason.error : {};

            console.log("paymentReason: ", paymentReason);
            console.log("field: ", field);
            console.log("step: ", step);
            console.log("code: ", code);

            // Reason 1 - when payment is cancelled. It can happen when we click cross icon or cancel any payment explicitly.
            if (reason === undefined) {
              console.log("cancelled");
            }
            // Reason 2 - When modal is auto closed because of time out
            else if (reason === "timeout") {
              console.log("timeout");
            }
            // Reason 3 - When payment gets failed.
            else {
              console.log("failure");
            }

            // ✅ Clean up if user closes checkout
            removeRazorpay();
          },
        },
        theme: {
          color: "#fbb040", // Set this to your brand's primary color
        },
        // This property allows to enble/disable retries.
        // This is enabled true by default.
        retry: {
          enabled: false,
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();
    }
  };

  const handlePlanSelect = (e) => {
    const selectedValue = e.target.value;
    const plan = subscriptionData.find((sub) => sub.gateway_plan_id === selectedValue);
    setSelectedPlan(plan || null);
  };

  const handleBuyNowButtonClick = async () => {
    if (!selectedPlan) {
      await alert("Please select a plan first");
      return;
    }
    setLoading(true);
    handleSubscribeNow(selectedPlan).finally(() => {
      setLoading(false);
    });
  };

  const handleChangePlanButtonClick = async () => {
    let confirmMessage = "Are you sure you want to upgrade your current plan?";
    if (mySubscription?.sellerInfo?.app_features === "leads") {
      if (!isEmpty(mySubscription?.invoices) && mySubscription?.invoices?.length > 0) {
        const currentInvoice = mySubscription?.invoices[mySubscription?.invoices?.length - 1];
        if (!isEmpty(currentInvoice)) {
          const currentInvoiceEnd = TimestampConverter(currentInvoice?.billing_end * 1000, true);
          confirmMessage = `You are already subscribed to a Leads payment plan that is ending on ${currentInvoiceEnd}. Are you sure you want to upgrade now?`;
        }
      }
    }

    const isConfirmed = await confirm(confirmMessage, "");
    if (isConfirmed) {
      setShowChangePlan(true);
    } else {
      setShowChangePlan(false);
    }
  };

  const renderMySubscription = () => {
    if (!mySubscription) {
      return <div>You do not have an active subscription.</div>;
    }

    return (
      <Row className="m-0 p-0">
        {/* IMPORTANT: DialogModal must be rendered somewhere in your component tree */}
        {DialogModal}
        <Col className="col-12 col-sm-5 col-md-5">
          <div className="my-2 p-3 border rounded bg-white">
            <h5>
              <strong>Current Plan</strong>
            </h5>
            <div class="d-inline-flex align-items-center px-4 py-2 mb-1 border border-warning rounded-pill">
              <Image
                src={bhareeBlack}
                alt="Bharee Logo"
                className="starter-img"
                style={{
                  height: "15px",
                  objectFit: "contain",
                  marginRight: "10px",
                  marginTop: "-3px",
                }}
              />
              <span class="fw-bold text-danger starter-text">
                {capitalize(mySubscription?.sellerInfo?.app_features)}
              </span>
            </div>

            {mySubscription?.sellerInfo?.app_features === "leads" &&
              mySubscription?.sellerInfo?.is_trial && (
                <div className="text-center w-100 mt-2 small text-danger">
                  You are currently in trial mode. Your trial period will end on{" "}
                  {TimestampConverter(mySubscription?.sellerInfo?.trial_end_date, true)}.
                </div>
              )}

            {mySubscription?.sellerInfo?.app_features === "leads" &&
              isEmpty(mySubscription?.plan_details) &&
              !mySubscription?.sellerInfo?.is_trial && (
                <div className="text-center w-100 mt-2 small text-danger">
                  Your trial has ended on{" "}
                  {TimestampConverter(mySubscription?.sellerInfo?.trial_end_date, true)}.
                </div>
              )}

            {!isEmpty(bhareeFee) && (
              <div className="text-center w-100">
                <div className="d-flex justify-content-center align-items-baseline gap-1">
                  <h4 className="mb-0" style={{ color: "#fbb040", fontWeight: "bolder" }}>
                    {parseFloat(bhareeFee).toFixed(1)}%
                  </h4>
                  <p className="text-muted mb-0 small">Bharee Charges</p>
                </div>

                <p className="text-muted small mt-1">Success-based commission. GST @18% extra.</p>
              </div>
            )}

            {!isEmpty(mySubscription?.plan_details) &&
              mySubscription?.is_subscription_active &&
              mySubscription?.sellerInfo?.app_features === "leads" && (
                <>
                  <p className="mb-1">
                    <strong>{mySubscription?.plan_details?.plan_title}</strong>{" "}
                    <Button
                      variant="link"
                      size="sm"
                      onClick={() => {
                        setShowLeadsPlan(true);
                        setShowLeadsPlanClose(true);
                      }}
                    >
                      Change
                    </Button>
                    <br />
                    {mySubscription?.plan_details?.plan_subtitle}
                  </p>
                  <p className="mb-1 small">
                    <strong>Subscription ID:</strong> {mySubscription?.id}
                  </p>
                  <hr />
                  <p className="mb-1 small">
                    <strong>Customer ID:</strong> {mySubscription?.customer_id}
                  </p>
                  <p className="mb-1 small">
                    <strong>Plan ID:</strong> {mySubscription?.plan_id}
                  </p>
                  <p className="mb-1">
                    <strong>Status:</strong>{" "}
                    <span className="text-success fw-bold">
                      {mySubscription?.status?.toUpperCase()}
                    </span>
                  </p>
                  {mySubscription?.status === "active" && (
                    <>
                      <p className="mb-1 small">
                        <strong>Start Date:</strong>{" "}
                        {TimestampConverter(mySubscription?.current_start * 1000)}
                      </p>
                      <p className="mb-1 small">
                        <strong>Next Billing Date:</strong>{" "}
                        {TimestampConverter(mySubscription?.next_billing_date)}
                      </p>
                    </>
                  )}
                </>
              )}

            {!isEmpty(subscriptionDisplayFeatures) && subscriptionDisplayFeatures?.length > 0 && (
              <>
                <hr />
                <h5 className="mb-1">
                  <strong>Features</strong>
                </h5>

                {subscriptionDisplayFeatures?.map(([label, value], index) => (
                  <Row key={index} className="mb-0">
                    <Col md={6} xs={6} className="text-end small muted">
                      {label}
                    </Col>
                    <Col
                      md={6}
                      xs={6}
                      className="d-flex justify-content-start align-items-center"
                      style={{ fontWeight: "bold" }}
                    >
                      {value?.toLowerCase() === "yes" ? (
                        <i className="bi bi-check-lg text-success"></i>
                      ) : value?.toLowerCase() === "no" ? (
                        <i className="bi bi-x-lg text-danger"></i>
                      ) : (
                        <span className="small">{value}</span>
                      )}
                    </Col>
                  </Row>
                ))}
              </>
            )}
          </div>

          {mySubscription?.sellerInfo?.app_features !== "booster" && (
            <div>
              <Button
                variant="primary"
                className="btn-bharee"
                onClick={handleChangePlanButtonClick}
              >
                <i class="bi bi-chevron-double-up"></i> Upgrade Plan
              </Button>
            </div>
          )}
        </Col>

        <Col className="col-12 col-sm-7 col-md-7">
          {showLeadsPlan && (
            <div className="bg-white border rounded mt-2 mb-3 pb-3">
              <div className="mt-2 mx-md-5">
                {mySubscription?.sellerInfo?.is_trial
                  ? `Go through the following pricing plans and buy a paid plan before the trial period ends.`
                  : `Go through the following pricing plans and buy a paid plan.`}
              </div>
              <div className="bharee-booster-page mt-2 mx-md-5">
                {mySubscription?.sellerInfo?.app_features === "leads" && (
                  <>
                    <ButtonGroup>
                      {subscriptionData.map((radio, idx) => {
                        const isSelected = selectedPlan?.gateway_plan_id === radio.gateway_plan_id;
                        return (
                          <ToggleButton
                            key={idx}
                            id={`radio-${idx}`}
                            type="radio"
                            variant={isSelected ? "primary" : "outline-primary"}
                            name="radio"
                            value={radio.gateway_plan_id}
                            checked={isSelected}
                            onChange={(e) => {
                              handlePlanSelect(e);
                            }}
                          >
                            {radio.plan_title}
                          </ToggleButton>
                        );
                      })}
                    </ButtonGroup>

                    <div class="price-lg mt-2">
                      <span className="price-currency" style={{ fontSize: "28px" }}>
                        <i className="bi bi-currency-rupee"></i>
                      </span>
                      <span
                        className="price-amount"
                        style={{ fontSize: "54px", fontWeight: "bold" }}
                      >
                        {parseFloat(selectedPlan?.plan_unit_amount).toFixed(0)}
                        <span className="subtxt">/month</span>
                      </span>
                    </div>
                    <div class="subtxt">
                      <b>{selectedPlan?.plan_subtitle}</b>
                    </div>

                    <Row className="m-0 p-0 my-3">
                      <Col xs={7} className="text-end small">
                        Total Plan Amount
                      </Col>
                      <Col xs={5} className="text-end">
                        {selectedPlan?.plan_amount} <i className="bi bi-currency-rupee"></i>
                      </Col>
                      <Col xs={7} className="text-end small">
                        Total GST (18%)
                      </Col>
                      <Col xs={5} className="text-end">
                        {selectedPlan?.plan_gst} <i className="bi bi-currency-rupee"></i>
                      </Col>
                      <hr className="m-0 p-0" />
                      <Col xs={7} className="text-end small">
                        Total Amount (to be paid)
                      </Col>
                      <Col xs={5} className="text-end">
                        {selectedPlan?.plan_total_amount} <i className="bi bi-currency-rupee"></i>
                      </Col>
                    </Row>
                    <Row className="m-0 p-0">
                      <Col xs={12} md={6} className="text-start">
                        <Form.Check
                          type="checkbox"
                          id="terms-checkbox"
                          label={
                            <>
                              I agree to the{" "}
                              <a href="/terms" target="_blank" rel="noreferrer">
                                Terms & Conditions
                              </a>
                            </>
                          }
                          checked={acceptedTerms}
                          onChange={(e) => setAcceptedTerms(e.target.checked)}
                          className="mb-3"
                        />
                      </Col>
                      <Col xs={12} md={6}>
                        <div className="w-100 text-end">
                          {showLeadsPlanClose && (
                            <Button
                              variant="secondary"
                              onClick={() => {
                                setShowLeadsPlan(false);
                                setShowLeadsPlanClose(false);
                                setAcceptedTerms(false);
                              }}
                            >
                              <i className="bi bi-x-lg"></i> Close
                            </Button>
                          )}{" "}
                          <Button
                            variant="primary"
                            className="btn-bharee"
                            disabled={!acceptedTerms}
                            onClick={handleBuyNowButtonClick}
                          >
                            <i className="bi bi-currency-rupee"></i> Buy Now
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
              </div>
            </div>
          )}

          {mySubscription?.invoices && mySubscription?.invoices?.length > 0 && (
            <div className="my-2 border rounded">
              <CustomTable
                className="rounded"
                enableRowActions
                data={mySubscription?.invoices}
                enableTopToolbar={true}
                enableBottomToolbar={true}
                enablePagination={true}
                enableFilters={false}
                emptyTableMsg={`No invoices found`}
                positionActionsColumn={"last"}
                columns={tableStructures.subscription_invoices}
                initialState={{
                  columnPinning: {
                    right: ["mrt-row-actions"],
                  },
                }}
                renderTopToolbarCustomActions={({ table }) => (
                  <Row style={{ display: "flex", gap: "1rem", p: "0.5rem", flexWrap: "wrap" }}>
                    <h5>
                      <strong>Subscription Invoices</strong>
                    </h5>
                  </Row>
                )}
                renderRowActions={({ row, table }) => (
                  <div className="table-action-box">
                    <Button
                      buttonClasses="action-button text-white"
                      id={row.original.id}
                      onClick={() => {
                        navigate(`/seller/subscription/invoice/${row.original.id}`);
                      }}
                    >
                      <i className="bi bi-download"></i>
                    </Button>
                  </div>
                )}
              />
            </div>
          )}
        </Col>
      </Row>
    );
  };

  const onChangePlanClick = async (selectedAppFeature) => {
    setLoading(true);
    const lpData = await getLogisticPartners(auth?.user?.id, auth?.user?.role?.role_name, dispatch);
    if (!isEmpty(lpData)) {
      if (lpData?.data?.length > 0) {
        // Send a request to change the plan for seller
        const postUrl = BHAREE_BASE_URL_LOCAL + "/users/upgradeSubscription/" + auth?.user?.id;
        setLoading(true);
        const postRes = await axios
          .post(postUrl, { planType: selectedAppFeature }, options)
          .then((res) => {
            return res.data;
          })
          .finally(() => {
            setLoading(false);
          });

        // console.log("POST RESPONSE: ", postRes);
        if (!isEmpty(postRes)) {
          if (postRes?.success) {
            await alert(
              `You are now successfully upgraded to ${selectedAppFeature}. Please re-login.`,
            );
            store.dispatch(logoutUser());
            window.location.href = "/";
          } else {
            toast.error(postRes.message);
          }
        }
      } else {
        setLoading(false);
        await alert(
          `You have not registered any Logistic Partner yet. Please register at least one Logistic Partner first in order to change your plan to ${selectedAppFeature}.`,
        );
        dispatch({
          type: stringConstants.SET_CURRENT_VIEW,
          payload: stringConstants.LOGISTIC_PARTNER,
          currentViewObj: { fromSubscriptionUpgrade: true },
        });
      }
    }
    setLoading(false);
  };

  const renderChangePlan = () => {
    return (
      <>
        <Container fluid className="pt-2" style={{ backgroundColor: "#eee" }}>
          <div className="text-start">
            <Button
              variant="secondary"
              size="sm"
              onClick={() => {
                setShowChangePlan(false);
              }}
            >
              <i class="bi bi-chevron-left"></i> Back
            </Button>
          </div>
        </Container>
        {(() => {
          if (mySubscription?.sellerInfo?.app_features === "leads") {
            return (
              <BhareeSubscriptionGeneric
                showHeader={false}
                showLeads={false}
                changePlan={true}
                onChangePlanClick={onChangePlanClick}
              />
            );
          } else if (mySubscription?.sellerInfo?.app_features === "starter") {
            return (
              <BhareeSubscriptionGeneric
                showHeader={false}
                showStarter={false}
                showLeads={false}
                changePlan={true}
                onChangePlanClick={onChangePlanClick}
              />
            );
          } else if (mySubscription?.sellerInfo?.app_features === "booster") {
            return (
              <BhareeSubscriptionGeneric
                showHeader={false}
                showBooster={false}
                showLeads={false}
                changePlan={true}
                onChangePlanClick={onChangePlanClick}
              />
            );
          }
        })()}
      </>
    );
  };

  return (
    <>
      {DialogModal}
      {loading && <PageSpinner />}
      {!showChangePlan ? renderMySubscription() : renderChangePlan()}
    </>
  );
};

export default Subscriptions;
